const locations = {
  REFRIGERATOR: 'Geladeira',
  ENVIRONMENT: 'Ambiente',
};

export default locations;
